module.exports = __webpack_public_path__ + "img/buyHomeBannerPhone2.23b30ec7.png";